import { IonLabel, IonToggle } from "@ionic/react";
import { Colors } from "swing-components";

import { translate } from "~utils";

type ToggleProps = {
  label?: string;
  isSelected?: boolean;
  onToggleChange: (e: boolean) => void;
  hasDivider?: boolean;
  disabled?: boolean;
};

export function Toggle(props: ToggleProps) {
  const { label, isSelected = false, onToggleChange, hasDivider = false, disabled = false } = props;
  // TODO try to remove Ionic components
  return (
    <div
      css={{
        display: "flex",
        padding: "16px 0",
        alignItems: "center",
        width: "inherit",
        justifyContent: "space-between",
        borderBottom: hasDivider ? `1px solid ${Colors.slate200}` : "none",
      }}
    >
      {label && (
        <IonLabel>
          <span style={{ fontWeight: "var(--swing-font-semibold" }}>{label}</span>
        </IonLabel>
      )}

      <IonToggle
        aria-checked={true}
        aria-label={
          isSelected
            ? `${label} ${translate("ARIA_LABEL_SELECTED")}`
            : `${label} ${translate("ARIA_LABEL_DESELECTED")}`
        }
        checked={isSelected}
        disabled={disabled}
        onIonChange={(e: CustomEvent) => {
          onToggleChange(e.detail.checked);
        }}
        slot="end"
      />
    </div>
  );
}
